<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-breadcrumbs>
        <v-breadcrumbs-item>
          <v-icon left>home</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item>Billing</v-breadcrumbs-item>
        <v-breadcrumbs-item>{{
          $app.capitalizeFirstLetter($route.params.filter)
        }}</v-breadcrumbs-item>
      </v-breadcrumbs>
      <connection-manager ref="connectionManager" v-model="connecting">
      </connection-manager>
      <v-card class="pt-3" v-if="filter">
        <v-toolbar color="transparent" dense flat card>
          <v-text-field
            class="ml-5"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          >
          </v-text-field>
          <v-menu offset-y>
            <v-btn small flat outline color="primary" slot="activator">
              <v-icon left>date_range</v-icon>
              {{ month }}
            </v-btn>
            <v-date-picker
              v-model="month"
              type="month"
              landscape
              :min="minMonth"
              :max="maxMonth"
            >
            </v-date-picker>
          </v-menu>

          <v-btn small flat outline color="primary">
            <v-icon left>file_download</v-icon>
            Download
          </v-btn>
          <v-btn small flat outline @click="refresh(1)" color="primary">
            <v-icon left>refresh</v-icon>
            Refresh
          </v-btn>
        </v-toolbar>
        <v-data-table
          ref="dataTable"
          :headers="isAdmin() || isOperations() ? adminHeaders : clientHeaders"
          :items="items"
          :search="search"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td v-if="isAdmin() || isOperations()">
              {{ props.item.client.name }}
            </td>
            <td>{{ $app.formatMoney(props.item.amount) }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.description }}</td>
            <td>{{ props.item.createdAt }}</td>
          </template>
        </v-data-table>
        <Pagination
          v-if="paginate"
          :totalPages.sync="paginationState.totalPages"
          :currentPage.sync="paginationState.currentPage"
          @pagechanged="pagechanged"
        ></Pagination>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Base from './Base.vue'
import DateInput from './DateInput'
import moment from 'moment'
import Pagination from './Pagination.vue'
import ConnectionManager from './ConnectionManager'

export default {
  components: { ConnectionManager, DateInput, Pagination },
  name: 'Billing',
  extends: Base,
  data() {
    return {
      adminHeaders: [
        { text: 'Id', sortable: false, value: 'id' },
        { text: 'Client', sortable: false, value: 'client' },
        { text: 'Amount', sortable: false, value: 'amount' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Description', sortable: false, value: 'description' },
        { text: 'Date/Time', sortable: false, value: 'createdAt' }
      ],
      clientHeaders: [
        { text: 'Id', sortable: false, value: 'id' },
        { text: 'Amount', sortable: false, value: 'amount' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Description', sortable: false, value: 'description' },
        { text: 'Date/Time', sortable: false, value: 'createdAt' }
      ],
      search: '',
      filter: 'courier',
      connecting: false,
      month: null,
      minMonth: null,
      maxMonth: null,
      rowsPerPageItems: [10],
      pagination: {
        rowsPerPage: 10
      },
      paginate: true,
      items: [],
      paginationState: {
        perPage: 10,
        currentPage: 1,
        totalPages: 5,
        totalCount: 0
      }
    }
  },
  methods: {
    pagechanged(nextPage) {
      this.refresh(nextPage)
    },
    refresh(nextPage) {
      // this.$refs.dataTable.pageStart = 0
      this.items = []
      let that = this
      this.$refs.connectionManager.get(
        'bills',
        {
          onSuccess(response) {
            that.items = that.items.concat(response.data.data)
            if (response.data.paginator) {
              let paginator = response.data.paginator
              that.paginationState.totalPages = paginator.totalPages
              that.paginationState.totalCount = paginator.totalCount
              that.paginationState.currentPage = paginator.currentPage
            }
          }
        },
        {
          filter: this.filter,
          month: this.month,
          page: nextPage,
          paginate: 1,
          size: this.paginationState.perPage
        }
      )
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.params.filter !== this.filter) {
        this.filter = to.params.filter
      }
    },
    month(month) {
      if (month && this.filter && !this.connecting) {
        this.refresh(1)
      }
    },
    filter(val) {
      if (this.month && val && !this.connecting) {
        this.refresh(1)
      }
    }
  },
  mounted() {
    let today = moment()
    let todayMonth = today.month() + 1
    if (todayMonth < 10) {
      todayMonth = '0' + todayMonth
    }

    if (this.isAdmin() || this.isOperations()) {
      this.month = today.year() + '-' + todayMonth
    } else {
      let dateClientJoined = moment(this.$auth.user().client.createdAt)
      this.minMonth = dateClientJoined.year() + '-' + dateClientJoined.month()
      this.maxMonth = today.year() + '-' + (today.month() + 2)
      this.month = today.year() + '-' + todayMonth
    }
  },
  created() {
    this.filter = this.$route.params.filter
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Billing.vue